import { Component, OnInit,ViewChild } from '@angular/core';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { role } from '../models/role';
import { ToastrManager } from 'ng6-toastr-notifications';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ExcelService } from '../service/tableUtility.service';
@Component({
  selector: 'app-rolemanagement',
  templateUrl: './rolemanagement.component.html',
  styleUrls: ['./rolemanagement.component.css']
})
export class RolemanagementComponent implements OnInit {
  tabledata:any = {
    "role_name": "",
    "component_name": {
      "admin_management": {
        "permissions": [
          {
            "read": false,
            "write": false,
            "delete": false,
            "export":false
          }
        ]
      },
      "role_management": {
        "permissions": [
          {
            "read": false,
            "write": false,
            "delete": false,
            "export":false          }
        ]
      },
      "user_management": {
        "permissions": [
          {
            "read": false,
            "write": false,
            "delete": false,
            "export":false          }
        ]
      },
      "userAccount_management": {
        "permissions": [
          {
            "read": false,
            "write": false,
            "delete": false,
            "export":false          }
        ]
      },
      "currentInventory_management": {
        "permissions": [
          {
            "read": false,
            "write": false,
            "delete": false,
            "export":false          }
        ]
      },
      "openOrders_management": {
        "permissions": [
          {
            "read": false,
            "write": false,
            "delete": false,
            "export":false          }
        ]
      },
      "shoppingCart_management": {
        "permissions": [
          {
            "read": false,
            "write": false,
            "delete": false,
            "export":false          }
        ]
      },
      "savedList_management": {
        "permissions": [
          {
            "read": false,
            "write": false,
            "delete": false,
            "export":false          }
        ]
      },
      "orderHistory_management": {
        "permissions": [
          {
            "read": false,
            "write": false,
            "delete": false,
            "export":false          }
        ]
      },
      "sysLogs_management": {
        "permissions": [
          {
            "read": false,
            "write": false,
            "delete": false,
            "export":false          }
        ]
      },
      "vendors_management": {
        "permissions": [
          {
            "read": false,
            "write": false,
            "delete": false,
            "export":false          }
        ]
      },
      "pageContent_management": {
        "permissions": [
          {
            "read": false,
            "write": false,
            "delete": false,
            "export":false          }
        ]
      },
      "banner_management": {
        "permissions": [
          {
            "read": false,
            "write": false,
            "delete": false,
            "export":false          }
        ]
      },
    "appNotificationtext_management": {
        "permissions": [
          {
            "read": false,
            "write": false,
            "delete": false,
            "export":false          }
        ]
      },
      "emailNotificationtext_management": {
        "permissions": [
          {
            "read": false,
            "write": false,
            "delete": false,
            "export":false          }
        ]
      },
      "smsNotificationtext_management": {
        "permissions": [
          {
            "read": false,
            "write": false,
            "delete": false,
            "export":false          }
        ]
      },
    }
  }
  read:any;
  write:any;
  delete:any
  filterValueSelected:any
  tableUpdatedData:any
  Updatetabledata:any
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("role") form: any;
  @ViewChild("roleUpdate") formUpdate: any;
  dataSource: any;
  displayedColumns = ['id', 'role_name','status','createdDate','dateOfLastModification', 'Action']
  show:boolean=false
  showFilter:boolean=false
  roleAddObj:role
  showCustomisedSearch: boolean = false
  searchValue:any
  componentsList:any
  marked = false;
  userSession: any;
  userDetails: any;
  userSessionData: any;
role:any
table:[]=[]
  showUpdate: boolean=false;
  constructor(private cs:CucurachaAdminService,private toastr: ToastrManager, private excelService: ExcelService) {
    this.roleAddObj=new role();
   }
  addRole(){
    if(this.show==false){
      this.show=true
      this.form.reset();
      this.formUpdate.reset()

    }
    else{
      this.show=false
      this.form.reset();
      this.formUpdate.reset();

    }
  }
  onChange(status, id,roleid) {
    console.log(status.checked)
   
      this.cs.updateRolestatus(status.checked,id,roleid).subscribe((data) => {
        if(data.result ){
          this.toastr.successToastr("Updated Succesfully");
          this.getAllRoles()

          }
         else if(data.err){
          this.toastr.warningToastr(data.message);
    
         }
          else{
            this.toastr.errorToastr(data.message);
    
          }
      })
  
     
    
  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
  applyCustomizedFilter() {
    this.showCustomisedSearch = true
    this.searchValue=""
    this.getAllRoles();

  }
  applyCustomizedFilterSearch(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue;

    if (filterValue != "") {
      this.cs.customizedFilterForRole(this.filterValueSelected, filterValue).subscribe((data) => {
        console.log(data)
        this.dataSource = new MatTableDataSource(data)

      })
    }
    else {
      this.getAllRoles()
    }
  }
  filter() {
    this.getAllRoles()
    if (this.showFilter == false) {
      this.showFilter = true
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""


      this.form.reset();

    }
    else {
      this.showFilter = false
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""

      this.form.reset();



    }
  }
  
  submittData() {
   
    let seconddata:any = [];
    let obj = {
      "role_name":this.tabledata.role_name ? this.tabledata.role_name : '',
      
      "component_name": [this.tabledata.component_name],
    }
    console.log(obj)
    this.cs.savePermissions(obj).subscribe((data:any)=>{
      if(data.result ){
        this.getAllRoles();
        this.show=false
        this.toastr.successToastr(data.message);
        this.form.reset();
        
        }
       else if(data.err){
        this.toastr.warningToastr(data.message);
  
       }
        else{
          this.toastr.errorToastr(data.message);
  
        }
    })

  }
  getRoleById(id:any){
    this.showUpdate=true
    this.cs.getRoleById(id).subscribe((data) => {
      console.log(data[0])
     this.tabledata = {
       "_id":data[0]._id,
      "roleId":data[0].id,
      "role_name":data[0].role_name,
      "component_name": {
        "admin_management": {
          "permissions": [
            {
              "read": data[0].components[0].component_name[0][0].admin_management.permissions[0].read,
              "write": data[0].components[0].component_name[0][0].admin_management.permissions[0].write,
              "delete":  data[0].components[0].component_name[0][0].admin_management.permissions[0].delete,
              "export":data[0].components[0].component_name[0][0].admin_management.permissions[0].export,     

            }
          ]
        },
        "role_management": {
          "permissions": [
            {
              "read": data[0].components[0].component_name[0][0].role_management.permissions[0].read,
              "write": data[0].components[0].component_name[0][0].role_management.permissions[0].write,
              "delete":  data[0].components[0].component_name[0][0].role_management.permissions[0].delete,
              "export":data[0].components[0].component_name[0][0].role_management.permissions[0].export,     
    
                 }
          ]
        },
        "user_management": {
          "permissions": [
            {
              "read": data[0].components[0].component_name[0][0].user_management.permissions[0].read,
              "write": data[0].components[0].component_name[0][0].user_management.permissions[0].write,
              "delete":  data[0].components[0].component_name[0][0].user_management.permissions[0].delete,
              "export":data[0].components[0].component_name[0][0].user_management.permissions[0].export,     

            }
          ]
        },
        "userAccount_management": {
          "permissions": [
            {
              "read": data[0].components[0].component_name[0][0].userAccount_management.permissions[0].read,
              "write": data[0].components[0].component_name[0][0].userAccount_management.permissions[0].write,
              "delete":  data[0].components[0].component_name[0][0].userAccount_management.permissions[0].delete,
              "export":data[0].components[0].component_name[0][0].userAccount_management.permissions[0].export,     

            }
          ]
        },
        "currentInventory_management": {
          "permissions": [
            {
              "read": data[0].components[0].component_name[0][0].currentInventory_management.permissions[0].read,
              "write": data[0].components[0].component_name[0][0].currentInventory_management.permissions[0].write,
              "delete":  data[0].components[0].component_name[0][0].currentInventory_management.permissions[0].delete,
              "export":data[0].components[0].component_name[0][0].currentInventory_management.permissions[0].export,     

            }
          ]
        },
        "openOrders_management": {
          "permissions": [
            {
              "read": data[0].components[0].component_name[0][0].openOrders_management.permissions[0].read,
              "write": data[0].components[0].component_name[0][0].openOrders_management.permissions[0].write,
              "delete":  data[0].components[0].component_name[0][0].openOrders_management.permissions[0].delete,
              "export":data[0].components[0].component_name[0][0].openOrders_management.permissions[0].export,     

            }
          ]
        },
        "shoppingCart_management": {
          "permissions": [
            {
              "read": data[0].components[0].component_name[0][0].shoppingCart_management.permissions[0].read,
              "write": data[0].components[0].component_name[0][0].shoppingCart_management.permissions[0].write,
              "delete":  data[0].components[0].component_name[0][0].shoppingCart_management.permissions[0].delete,
              "export":data[0].components[0].component_name[0][0].shoppingCart_management.permissions[0].export,     

            }
          ]
        },
        "savedList_management": {
          "permissions": [
            {
              "read": data[0].components[0].component_name[0][0].savedList_management.permissions[0].read,
              "write": data[0].components[0].component_name[0][0].savedList_management.permissions[0].write,
              "delete":  data[0].components[0].component_name[0][0].savedList_management.permissions[0].delete,
              "export":data[0].components[0].component_name[0][0].savedList_management.permissions[0].export,     

            }
          ]
        },
        "orderHistory_management": {
          "permissions": [
            {
              "read": data[0].components[0].component_name[0][0].orderHistory_management.permissions[0].read,
              "write": data[0].components[0].component_name[0][0].orderHistory_management.permissions[0].write,
              "delete":  data[0].components[0].component_name[0][0].orderHistory_management.permissions[0].delete,
              "export":data[0].components[0].component_name[0][0].orderHistory_management.permissions[0].export,     
        }
          ]
        },
        "sysLogs_management": {
          "permissions": [
            {
              "read": data[0].components[0].component_name[0][0].sysLogs_management.permissions[0].read,
              "write": data[0].components[0].component_name[0][0].sysLogs_management.permissions[0].write,
              "delete":  data[0].components[0].component_name[0][0].sysLogs_management.permissions[0].delete,
              "export":data[0].components[0].component_name[0][0].sysLogs_management.permissions[0].export,     
        }
          ]
        },
        "vendors_management": {
          "permissions": [
            {
              "read": data[0].components[0].component_name[0][0].vendors_management.permissions[0].read,
              "write": data[0].components[0].component_name[0][0].vendors_management.permissions[0].write,
              "delete":  data[0].components[0].component_name[0][0].vendors_management.permissions[0].delete,
              "export":data[0].components[0].component_name[0][0].vendors_management.permissions[0].export,     

            }
          ]
        },
        "pageContent_management": {
          "permissions": [
            {
              "read": data[0].components[0].component_name[0][0].pageContent_management.permissions[0].read,
              "write": data[0].components[0].component_name[0][0].pageContent_management.permissions[0].write,
              "delete":  data[0].components[0].component_name[0][0].pageContent_management.permissions[0].delete,
              "export":data[0].components[0].component_name[0][0].pageContent_management.permissions[0].export,     

            }
          ]
        },
        "banner_management": {
          "permissions": [
            {
              "read": data[0].components[0].component_name[0][0].banner_management.permissions[0].read,
              "write": data[0].components[0].component_name[0][0].banner_management.permissions[0].write,
              "delete":  data[0].components[0].component_name[0][0].banner_management.permissions[0].delete,
              "export":data[0].components[0].component_name[0][0].banner_management.permissions[0].export,     

            }
          ]
        },
       "appNotificationtext_management": {
          "permissions": [
            {
              "read": data[0].components[0].component_name[0][0].appNotificationtext_management.permissions[0].read,
              "write": data[0].components[0].component_name[0][0].appNotificationtext_management.permissions[0].write,
              "delete":  data[0].components[0].component_name[0][0].appNotificationtext_management.permissions[0].delete,
              "export":data[0].components[0].component_name[0][0].appNotificationtext_management.permissions[0].export,     

            }
          ]
        },
        "emailNotificationtext_management": {
          "permissions": [
            {
              "read": data[0].components[0].component_name[0][0].emailNotificationtext_management.permissions[0].read,
              "write": data[0].components[0].component_name[0][0].emailNotificationtext_management.permissions[0].write,
              "delete":  data[0].components[0].component_name[0][0].emailNotificationtext_management.permissions[0].delete,
              "export":data[0].components[0].component_name[0][0].emailNotificationtext_management.permissions[0].export,     

            }
          ]
        },
        "smsNotificationtext_management": {
          "permissions": [
            {
              "read": data[0].components[0].component_name[0][0].smsNotificationtext_management.permissions[0].read,
              "write": data[0].components[0].component_name[0][0].smsNotificationtext_management.permissions[0].write,
              "delete":  data[0].components[0].component_name[0][0].smsNotificationtext_management.permissions[0].delete,
              "export":data[0].components[0].component_name[0][0].smsNotificationtext_management.permissions[0].export,     

            }
          ]
        },
      }
     }
  })
  }
  deleteRoleById(id:any,roleid:any){
    this.cs.deleteRoleById(id,roleid).subscribe((data:any)=>{
      if(data.result){
      this.toastr.errorToastr(data.message);
      this.getAllRoles()
      }
      else{
        this.toastr.warningToastr(data.message);
        this.getAllRoles()


      }
    })
  }
  updateData(){
    let obj = {
      "_id":this.tabledata._id ? this.tabledata._id : '',
      "role_name":this.tabledata.role_name ? this.tabledata.role_name : '',
      "component_name": [this.tabledata.component_name],
    }
    console.log(obj)
    this.cs.updatePermissions(obj).subscribe((data:any)=>{
      if(data.result ){
        this.getAllRoles();
        window.location.reload()

        this.toastr.infoToastr(data.message);
        this.formUpdate.reset();
        
        }
       else if(data.err){
        this.toastr.warningToastr(data.message);
  
       }
        else{
          this.toastr.errorToastr(data.message);
  
        }
    })
  }
  exportTable(){
    // TableUtil.exportToExcel("Example table",'usersManagement.xlsx');
    this.table = (this.dataSource.filteredData)
    console.log(this.table)
    this.excelService.exportAsExcelFile(this.table, 'Banner');
  }
  getAllRoles(){
    this.cs.getAllRoles().subscribe((data) => {
      this.dataSource = new MatTableDataSource(data)
  this.dataSource.sort = this.sort
  this.dataSource.paginator = this.paginator
    })
  }
  ngOnInit(): void {
    this.getAllRoles();
    this.userSessionData = (JSON.parse(localStorage.getItem('user')))

    this.cs.getUserDataByEmailId(this.userSessionData).subscribe((data) => {
      this.userDetails = data[0]
      this.read = (this.userDetails.roledetails[0].components[0].component_name[0][0].role_management.permissions[0].read);
      this.write = (this.userDetails.roledetails[0].components[0].component_name[0][0].role_management.permissions[0].write)
      this.delete = (this.userDetails.roledetails[0].components[0].component_name[0][0].role_management.permissions[0].delete)
    })
  }

}
